// extracted by mini-css-extract-plugin
module.exports = {"root":"Images45_root__Ynum0","title":"Images45_title__2nR0r","images":"Images45_images__24q3o"};